// extracted by mini-css-extract-plugin
module.exports = {"base":"LogoHorizontal-base-38kbA","hiddenTitle":"LogoHorizontal-hiddenTitle-dhoKJ"};